<template>
  <!--
    Vuetify 2 の column / row / xs6 を以下となるようVuetify 3用に修正。
    フォームの「姓・名」「郵便番号・住所」のように、横に2つ並べたい入力欄を、画面サイズに応じて自動でレイアウトします。
    ・広い画面（sm 以上） → 左右2列（各50%）
    ・狭い画面（xs） → 縦に積み上げ（各100%）
    ・reverse prop も横並び時に反映
    説明
    ・cols="12": xs では全幅
    ・sm="6": sm 以上では半分幅
    ・#first / #second スロット: 左列・右列に入れる内容
    ・flex-column: xs 時に縦並び
    ・flex-column-reverse: reverse 時に上下を入れ替え（2列表示で first と second の左右を入れ替え, flex-column と flex-column-reverse は同時に付けない）
    ・flex-row-reverse: reverse 時に左右を入れ替え（2列表示で first と second の左右を入れ替え）
    ・ga-3: 縦並び時の列間ギャップ
    ・stackVertically — Vuetify のブレークポイント xs（600px未満）のとき true になり、縦積みになります。
  -->
  <v-row
    :class="{
      'flex-column': stackVertically && !reverse,
      'flex-column-reverse': stackVertically && reverse,
      'flex-row-reverse': !stackVertically && reverse,
      'ga-3': stackVertically
    }"
  >
    <v-col
      cols="12"
      sm="6"
    >
      <slot name="first" />
    </v-col>

    <v-col
      cols="12"
      sm="6"
    >
      <slot name="second" />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    props: {
      reverse: Boolean
    },
    computed: {
      stackVertically () {
        return this.$vuetify.display.xs
      }
    }
  }
</script>
